export default __webpack_public_path__ + "static/media/border-vertical-3.d7ed6d24.png";